<template>
  <div>
    <div class="page-title">編輯作業</div>
    <div class="page-box">
      <jobFrom :formLabelAlign="formLabelAlign" ref="form"></jobFrom>
      <div class="page-notice">請注意：標有 (<span class="star-mark">*</span>) 的為必填項。</div>
      <div class="page-button">
        <el-button type="info" @click="onSubmit">提交</el-button>
        <el-button type=" success" @click="backIndexpage">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import {getHomeworksDetail,putHomeworks} from '@/api/homeworks'
import jobFrom from "./components/jobFrom.vue";
export default {
  components: { jobFrom },
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
     formLabelAlign: {
        number: null,
        lang: null,
        gradeId: null,
        grade: {
          name: null,
          price: null,
        },
        startDate: null,
        endDate: null,
        passScore: null,
        homeworkScopes: [
          {
            topicNumber: null,
            practiseNumber: null,
            randomNumber: null,
          },
        ],
        students: [
         
        ],
      },
    };
  },
  created(){
     this.getHomeworksDetail()
  },
  methods: {
    onSubmit() {
      this.putHomeworks()
    },
   
    putHomeworks(){
      putHomeworks(this.id,this.formLabelAlign).then(()=>{
          this.$message({
            message: '編輯成功',
            type: 'success'
          })
          this.$router.push({ name: 'job' })
      })
    },
    backIndexpage() {
      this.$router.push('/job')
    },
    getHomeworksDetail(){
       getHomeworksDetail(this.id).then((v)=>{
           this.formLabelAlign = v.data
       })
    }
  },
};
</script>

<style lang="scss" scoped>
.page-box {
  padding: 20px;
  background-color: #fff;
  margin-top: 20px;
}
.page-notice{
  margin-top: 20px;
}
</style>